import { Suspense } from 'react';
import { Button, Dropdown, LazyLoader, NotificationActiveIcon, NotificationDefaultIcon } from '@bp/ui-components';
import styles from '../_Flyouts.module.scss';
import classNames from 'classnames';
import { useMatrixClient } from '../../../../hooks/matrix/useMatrixClient';
import { NotificationsFlyoutContent } from './NotificationsFlyoutContent';

type NotificationsFlyoutProps = { navigate: (to: string) => void };

const NotificationsFlyout = ({ navigate }: NotificationsFlyoutProps) => {
  const { client: matrixClient, markAllAsUnread, hasUnread } = useMatrixClient();

  return (
    <Dropdown
      noPadding
      className={styles.flyout}
      trigger={
        <Button
          hierarchy='tertiary'
          icon={
            hasUnread ? (
              <NotificationActiveIcon className={classNames('svg-icon', styles['notifications-active'])} />
            ) : (
              <NotificationDefaultIcon />
            )
          }
        />
      }
    >
      <Suspense fallback={<LazyLoader embedded transparent />}>
        <NotificationsFlyoutContent
          navigate={navigate}
          setRoomReadMarkers={matrixClient?.setRoomReadMarkers}
          handleMarkAsUnreadClick={markAllAsUnread}
        />
      </Suspense>
    </Dropdown>
  );
};

export { NotificationsFlyout };
